import React, { useRef } from "react";
import { ImagePlus, X } from "lucide-react";
import { useLang } from "@/lib/i18n";

export default function PhotoInput({ value, onChange, label, testId = "photo-input" }) {
  const { t } = useLang();
  const ref = useRef(null);
  const onFile = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 3 * 1024 * 1024) {
      alert(t("maxImageSize"));
      return;
    }
    const reader = new FileReader();
    reader.onload = () => onChange(reader.result);
    reader.readAsDataURL(file);
  };

  if (value) {
    return (
      <div className="relative inline-block">
        <img src={value} alt="" className="h-32 w-32 rounded-2xl object-cover border border-zinc-200" />
        <button
          type="button"
          data-testid={`${testId}-remove`}
          onClick={() => onChange(null)}
          aria-label={t("removePhoto")}
          className="absolute -top-2 -right-2 h-7 w-7 rounded-full bg-zinc-900 text-white grid place-items-center shadow"
        >
          <X className="h-4 w-4" aria-hidden="true" />
        </button>
      </div>
    );
  }

  return (
    <button
      type="button"
      data-testid={testId}
      onClick={() => ref.current?.click()}
      className="flex flex-col items-center justify-center h-32 w-32 rounded-2xl border-2 border-dashed border-zinc-300 hover:border-emerald-500 text-zinc-500 hover:text-emerald-600 transition gap-1"
    >
      <ImagePlus className="h-6 w-6" />
      <span className="text-xs">{label}</span>
      <input ref={ref} type="file" accept="image/*" onChange={onFile} className="hidden" />
    </button>
  );
}
